import api from 'api/apiInstance';

export function clientCaseFinancialPlanningGoalsPrintApi(path: string) {
  return {
    path,
    GET: () => api.get(path),
  };
}
